import { Forbiddenpage } from "src/components/PageState/ForbiddenPage";
import { RemoteErrorAlert } from "src/components/PageState/RemoteErrorAlert";
import { CreatePackagingElement } from "./Element/CreatePackagingElement";
import { CreatePackagingComposite } from "./Composite/CreatePackagingComposite";
import { usePackagingContext } from "../PackagingDetails/PackagingContext";

/**
 * Edit-screen dispatcher. After the STI split (`PackagingElement` vs
 * `PackagingComposite`), the modern create flows already cover the full
 * shape of each subclass — we reuse them in edit mode by passing
 * `existing`, so users see exactly the same form whether they create or
 * modify a row.
 *
 * Routing rules:
 *  - `@type === "PackagingElement"` → modern element form, rendered to users
 *    as a Component.
 *  - `@type === "PackagingComposite"` → modern composite form, rendered to
 *    users as a Unit, in generic mode when `packagingReferenceCompositeId`
 *    is set, otherwise in specific mode pre-filled with `composition[]`.
 */
export const UpdatePackaging = () => {
    const { packaging } = usePackagingContext();

    if (packaging === undefined) {
        // ID is wrong or RBAC blocks the read — the parent route's error
        // boundary handles the user-visible state.
        return null;
    }

    if (packaging.canModify === false) {
        return <Forbiddenpage />;
    }

    const discriminator = packaging["@type"];

    if (discriminator === "PackagingElement") {
        return <CreatePackagingElement existing={packaging} />;
    }

    if (discriminator === "PackagingComposite") {
        return <CreatePackagingComposite existing={packaging} />;
    }

    return (
        <RemoteErrorAlert message="This packaging must be migrated before it can be edited." status="contract-error" />
    );
};
